import type { MessageTemplate } from '../../conversations/services/conversationService';

export const pickDefaultTemplateKey = (
  category: string | null | undefined,
  templates: MessageTemplate[],
): string => {
  const names = templates.map((template) => template.name);
  if (category === 'tasks' && names.includes('task_due_reminder')) {
    return 'task_due_reminder';
  }
  if (category === 'calendar' && names.includes('appointment_reminder')) {
    return 'appointment_reminder';
  }
  if (category === 'calendar-employee' && names.includes('appointment_staff_reminder')) {
    return 'appointment_staff_reminder';
  }
  return names[0] ?? '';
};

export const findMessageTemplate = (
  templates: MessageTemplate[],
  templateKey: string,
): MessageTemplate | undefined =>
  templates.find((template) => template.name === templateKey);

export const truncateTemplatePreview = (content: string, maxLength = 120): string => {
  const normalized = content.replace(/\s+/g, ' ').trim();
  if (normalized.length <= maxLength) {
    return normalized;
  }
  return `${normalized.slice(0, maxLength - 1)}…`;
};
